import {
  ANSWER_UPDATED,
  ANSWER_VALIDATED,
  CONQUEST_STATE_RESET
} from './conquest.actions';

export const initialState = {
  answer: {},
  isReady: false,
  validation: null,
  keypadRef: null,
  isKeypadActivated: true
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ANSWER_UPDATED: {
      return {
        ...state,
        ...action.payload
      };
    }

    case ANSWER_VALIDATED: {
      return {
        ...state,
        validation: action.validation
      };
    }

    case CONQUEST_STATE_RESET: {
      return {
        ...state,
        answer: {},
        isReady: false,
        validation: null
      };
    }

    default:
      return state;
  }
};
